/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import './index.scss';

import '../styles/global.scss';

const TemplateWrapper = ({ children }) => (
  <React.Fragment>
    <Helmet
      title="Hack the North"
      link={[{
          rel: 'apple-touch-icon', sizes: '180x180', href: 'assets/apple-touch-icon.png',
        }, {
          rel: 'icon', type: 'image/png', sizes: '32x32', href: 'assets/favicon-32x32.png',
        }, {
          rel: 'icon', type: 'image/png', sizes: '16x16', href: 'assets/favicon-16x16.png',
        }, {
          rel: 'mask-icon', href: '/safari-pinned-tab.svg', color: '#0e0e1c',
        }, {
          rel: 'shortcut icon', href: 'favicon.ico',
        }, {
          rel: 'manifest', href: '/manifest.json',
        },
      ]}
      meta={[
        { name: 'description', content: 'Hack the North is Canada\'s biggest hackathon, happening on September 14-16, 2018 at the University of Waterloo.' },
        { name: 'msapplication-TileColor', content: '#0e0e1c' },
        { name: 'theme-color', content: '#0e0e1c' },
        { name: 'apple-mobile-web-app-capable', content: 'yes' },
        { name: 'apple-mobile-web-app-status-bar-style', content: '#0e0e1c' },
        { name: 'apple-mobile-web-app-title', content: 'Hack the North' },
        { property: 'og:description', content: 'Hack the North is Canada\'s biggest hackathon, happening on September 14-16, 2018 at the University of Waterloo.' },
        { property: 'og:title', content: 'Hack the North' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://hackthenorth.com' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Hack the North' },
        { name: 'twitter:description', content: 'Hack the North is Canada\'s biggest hackathon, happening on September 14-16, 2018 at the University of Waterloo.' },
        { name: 'twitter:site', content: '@hackthenorth' },
        { name: 'twitter:creator', content: '@hackthenorth' },
        { property: 'og:image', content: 'https://hackthenorth.com/assets/facebook-share-image.png' },
        { name: 'twitter:image', content: 'https://hackthenorth.com/assets/twitter-share-image.png' },
      ]}
    >
      <html lang="en" />
      <script src="//d2wy8f7a9ursnm.cloudfront.net/v4/bugsnag.min.js" />
      <script type="text/javascript">
        {`
          window.bugsnagClient = bugsnag({
            apiKey: '4b5d7e5336975d37abfdba13d8a07cce',
            beforeSend: function (report) {
              // remove service workers if error before page is shown
              var spinner = document.querySelector('#___gatsby>.loading-spinner');
              if (window.navigator && navigator.serviceWorker && spinner != null) {
                navigator.serviceWorker.getRegistrations().then(function(registrations) {
                  for(let registration of registrations) {
                    registration.unregister();
                  }
                  // prevent infinite loop
                  if (sessionStorage.getItem('bug-reload') == null) {
                    sessionStorage.setItem('bug-reload', true);
                    location.reload(true);
                  } else {
                    sessionStorage.removeItem('bug-reload');
                  }
                });
              }
            }
          });
        `}
      </script>
      <script type="application/javascript" src="https://static.hackthenorth.com/hackerapi.js/1.0.16/hackerapi.web.js" />
    </Helmet>
    {children()}
  </React.Fragment>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func.isRequired,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx